module.exports = __webpack_public_path__ + "img/Bank Woori Saudara.9237817d.png";